import React from "react";
import { Link } from "react-router-dom";

function Footer() {
  return (
    <>
      <footer className="footer" id="footer">
        <div className="footer">
          <div className="container">
            <div className="row">
              <div className="col-lg-6 col-md-6">
                <div className="footer-box">
                  <h3>MACROZION</h3>
                  <p>
                    Nexus Glorious<br></br>
                    Old Mahahunge Road, Sus, Baner<br></br>
                    Pune-411021, Maharashtra, INDIA.<br></br>
                    <strong>Phone:</strong> +91 9665433121<br></br>
                    <strong>Email:</strong> support@macroziontechsystem.com
                    <br></br>
                  </p>

                  <div className="social-icon">
                    <ul>
                      <li>
                        <a href="/">
                          <i className="tf-ion-social-facebook"></i>
                        </a>
                      </li>
                      <li>
                        <a href="/">
                          <i className="tf-ion-social-twitter"></i>
                        </a>
                      </li>
                      <li>
                        <a href="/">
                          <i className="tf-ion-social-dribbble-outline"></i>
                        </a>
                      </li>
                      <li>
                        <a href="/">
                          <i className="tf-ion-social-linkedin-outline"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="col-lg-3 col-md-6 footer-links">
                <h4>Useful Links</h4>
                <ul>
                  <li>
                    <i className="bx bx-chevron-right"></i>{" "}
                    <Link className="footer-links" to="/">
                      Home
                    </Link>
                  </li>
                  <br></br>
                  <li>
                    <i className="bx bx-chevron-right"></i>{" "}
                    <Link className="footer-links" to="/about">
                      About us
                    </Link>
                  </li>
                  <br></br>
                  <li>
                    <i className="bx bx-chevron-right"></i>{" "}
                    <Link className="footer-links" to="/services">
                      Services
                    </Link>
                  </li>
                  <br></br>
                  <li>
                    <i className="bx bx-chevron-right"></i>{" "}
                    <Link className="footer-links" to="/career">
                      Career
                    </Link>
                  </li>
                  <br></br>
                  <li>
                    <i className="bx bx-chevron-right"></i>{" "}
                    <Link className="footer-links" to="/contact">
                      Contact us
                    </Link>
                  </li>
                  <br></br>
                  {/* <li>
                    <i className="bx bx-chevron-right"></i>{" "}
                    <Link className="footer-links" to="/">
                      Privacy policy
                    </Link>
                  </li> */}
                </ul>
              </div>

              <div className="col-lg-3 col-md-6 footer-links">
                <h4>Our Services</h4>
                <ul>
                  <li>
                    <i className="bx bx-chevron-right"></i>{" "}
                    <Link className="footer-links" to="/erp">
                      ERP
                    </Link>
                  </li>
                  <br></br>
                  <li>
                    <Link className="footer-links" to="/Sap">
                      SAP
                    </Link>
                  </li>
                  <br></br>

                  <li>
                    <i className="bx bx-chevron-right"></i>
                    <Link className="footer-links" to="/tally">
                      Tally
                    </Link>
                  </li>
                  <br></br>
                  <li>
                    <i className="bx bx-chevron-right"></i>
                    <Link className="footer-links" to="/itsupport">
                      IT Support
                    </Link>
                  </li>
                  <br></br>
                  <li>
                    <i className="bx bx-chevron-right"></i>
                    <Link className="footer-links" to="/payment">
                      Payment Gateway
                    </Link>
                  </li>
                  <br></br>
                  <li>
                    <i className="bx bx-chevron-right"></i>{" "}
                    <Link className="footer-links" to="/barcode">
                      Barcode system
                    </Link>
                  </li>
                </ul>
              </div>

              {/* <div className="col-lg-4 col-md-6 footer-newsletter">
                <h4>Subscribe Us</h4>
                <p>
                  Press the subscribe button after entering your email addess to
                  get in touch with us!
                </p>
                <form action="" method="post">
                  <input type="email" name="email" />
                  <input
                    type="submit"
                    className="subscribe"
                    value="Subscribe"
                  />
                </form>
                <br></br>
                <p>
                  By clicking "Subscribe" option, you agree to the Terms of
                  Service &amp; Privacy Policy
                </p>
              </div> */}
            </div>
          </div>
        </div>

        <div className="container footer-box">
          <div className="copyright">
            © Copyright{" "}
            <strong>
              <span>MACROZION Techsystem Pvt. Ltd.</span>
            </strong>{" "}
            All Rights Reserved
          </div>
          <div className="credits">
            Designed by{" "}
            <Link to="https://macroziontechsystem.com/">
              Macrozion Techsystem
            </Link>
          </div>
        </div>
      </footer>
    </>
  );
}

export default Footer;
